import React, { Component, Fragment, createRef } from 'react'
import { ReportModel, EditReportModel } from './models'
import { ReportList } from './ReportList'
import { Link, Route } from "react-router-dom";
import { Loader } from '../../../shared/loaders';
import { ButtonType } from '../../../shared/enums/button.enum';
import { Editor } from '../../../shared'
import { UserReportsService } from './services';
import { HttpResponse } from '../../../core';
import { ShowSuccessMessage, ValidateUrl, HandleNotFoundResponse } from '../../../shared/helpers';
import { ReportTabs } from './ReportTabs';
import { NotFoundResponseArea } from '../../../shared/enums';

interface IState {
    report?: ReportModel,
    editReport?: EditReportModel,
    id?: number,
    name?: string,
    time_range?: string,
    favicon_url?: string,
    enabled?: boolean,
    always_rebuild?: boolean,
    alert_on_failure?: boolean,
    query_strategy?: string;
    custom_sql?: string,
    nameError?: string,
    favUrlError?: string,
    isShowtext?: string;
    isSave?: string;
    isSaving?: boolean;
    ignore_health?: boolean;
    lookup_table_optimization?: boolean;
    incremental_load_optimization?: boolean;
    skip_when_priority_dependent_job?: boolean;
}
export class ReportForm extends Component<any, IState> {
    private service: UserReportsService;
    private nameRef: any;
    constructor(props) {
        super(props)
        this.state = this.initialState;
        this.editorhandleChange = this.editorhandleChange.bind(this);
        this.service = new UserReportsService();
        this.nameRef = createRef();
    }

    initialState: Partial<IState> = {
        alert_on_failure: false,
        always_rebuild: false,
        custom_sql: "",
        enabled: false,
        favicon_url: "",
        id: 0,
        isSave: "",
        isSaving: false,
        isShowtext: "",
        name: "",
        nameError: "",
        favUrlError: "",
        query_strategy: "v3",
        time_range: "",
        ignore_health: false,
        lookup_table_optimization: false,
        incremental_load_optimization: false,
        skip_when_priority_dependent_job: false,
        report: {
            alert_on_failure: false,
            always_rebuild: false,
            custom_sql: "",
            enabled: false,
            favicon_url: "",
            id: 0,
            name: "",
            query_strategy: "v3",
            time_range: "",
            ignore_health: false,
            lookup_table_optimization: false,
            incremental_load_optimization: false,
            skip_when_priority_dependent_job: false
        }
    }

    componentDidMount() {
        if (this.props.match.params.id > 0) {
            this.setState({ isShowtext: "Edit" })
            this.loadData();
        }
    }

    loadData() {
        this.service.editUserReport(this.props.match.params.id)
            .then((res: HttpResponse<EditReportModel>) => {
                if (res && res.result) {
                    this.setState({
                        alert_on_failure: res.result?.alert_on_failure == null ? false : res.result?.alert_on_failure,
                        always_rebuild: res.result?.always_rebuild == null ? false : res.result?.always_rebuild,
                        custom_sql: res.result?.custom_sql == null ? "" : res.result?.custom_sql,
                        enabled: res.result?.enabled == null ? false : res.result?.enabled,
                        favicon_url: res.result?.favicon_url == null ? "" : res.result?.favicon_url,
                        id: res.result?.id == null ? 0 : res.result?.id,
                        name: res.result?.name == null ? "" : res.result?.name,
                        query_strategy: res.result?.query_strategy == null ? "v3" : res.result?.query_strategy,
                        time_range: res.result?.time_range == null ? "" : res.result?.time_range,
                        ignore_health: res.result?.ignore_health == null ? false : res.result?.ignore_health,
                        lookup_table_optimization: res.result?.lookup_table_optimization == null ? false : res.result?.lookup_table_optimization,
                        incremental_load_optimization: res.result?.incremental_load_optimization == null ? false : res.result?.incremental_load_optimization,
                        skip_when_priority_dependent_job: res.result?.skip_when_priority_dependent_job == null ? false : res.result?.skip_when_priority_dependent_job

                    });
                }
            })
            .catch(ex => {
                HandleNotFoundResponse(ex,NotFoundResponseArea.Reports,this.props)
            });
    }



    updateData(report: ReportModel) {
        this.setSavingFlag(true);
        this.service.updateUserReport(report)
            .then((res: HttpResponse<ReportModel>) => {
                this.setSavingFlag(false);
                if (res && res.result) {
                    this.setState({
                        report: res.result
                    }, () => {
                        ShowSuccessMessage("Report successfully updated.");
                        if (this.state.isSave === ButtonType.Save) {
                            this.props.history.push('/report/detail/'+ this.state.id);
                            this.setState(this.initialState);
                        }
                        if (this.state.isSave === ButtonType.SaveAndAddAnother) {
                            this.setState(this.initialState);
                            this.props.history.push('/report/report-form/0');
                        }
                        if (this.state.isSave === ButtonType.SaveAndEdit) {
                            this.props.history.push('/report/report-form/' + this.state.report?.id);
                            this.setState({ isShowtext: "Edit" })
                        }
                    });

                }
            }, () => {
                this.setSavingFlag(false);
            });
    }


    editorhandleChange(data) {
        this.setState({ custom_sql: data })
    }

    handleChange = (event: any) => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        }, () => {
            // this.validate();
        })
        if (this.nameRef.current.value) {
            this.setState({ nameError: "" });
          }
    }

    handleSubmit = event => {
        event.preventDefault();
        const isValid = this.validate();
        let reportdata: ReportModel = {

            alert_on_failure: this.state.alert_on_failure,
            always_rebuild: this.state.always_rebuild,
            custom_sql: this.state.custom_sql,
            enabled: this.state.enabled,
            favicon_url: this.state.favicon_url,
            id: this.state.id,
            name: this.state.name,
            query_strategy: this.state.query_strategy,
            time_range: this.state.time_range,
            ignore_health: this.state?.ignore_health,
            lookup_table_optimization: this.state?.lookup_table_optimization,
            incremental_load_optimization: this.state?.incremental_load_optimization,
            skip_when_priority_dependent_job: this.state?.skip_when_priority_dependent_job
        };

        if (isValid) {
            this.updateData(reportdata);
        }
    }

    validate = () => {
        let evalUrlError = "";
        let nameError = "";
        if (!this.nameRef.current.value) {
            nameError = "Name can't be blank";
        }
        let evalFavUrl = ValidateUrl(this.state.favicon_url);
        if (!evalFavUrl && this.state.favicon_url) {
            evalUrlError = 'Favicon url must begin with https://';
        }

        if (nameError || evalUrlError) {
            this.setState({ nameError: nameError, favUrlError: evalUrlError })
            return false;
        }

        if (!evalUrlError || !nameError) {
            nameError = "";
            evalUrlError = "";
            this.setState({ nameError: nameError, favUrlError: evalUrlError })
            return true;
        }

    }

    handleClick = (event) => {
        this.setState({ isSave: event.target.value })
    }
    private setSavingFlag(saving: boolean) {
        this.setState({ isSaving: saving });
    }

    render() {
        return (
            <Fragment>
                <form onSubmit={this.handleSubmit}>
                    <input type="hidden" value={this.state.id} />
                    <div>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4>{this.state.isShowtext} Report {this.state.name && <span> '{this.state.name}'</span>}</h4>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                        {this.props.match.params.id != 0 && <ReportTabs id={this.props.match.params.id} url="/report/report-form/" />}
                                        <div className="row">

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Name<span className=" text-danger">*</span></label>
                                                    <input type="text"  ref={this.nameRef} maxLength={255} name="name" value={this.state.name} onChange={this.handleChange} className={!this.state.nameError ? 'form-control' : 'form-control  is-invalid'} />
                                                    <div className="invalid-feedback">
                                                        {this.state.nameError}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Time Range</label>
                                                    <input type="text" name="time_range" maxLength={255} value={this.state.time_range} onChange={this.handleChange} className="form-control" />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Favicon Url</label>
                                                    <input type="text" maxLength={255} name="favicon_url" value={this.state.favicon_url || ''} onChange={this.handleChange} className={!this.state.favUrlError ? 'form-control' : 'form-control  is-invalid'} />
                                                    {/* <div className="hint-text">Optional. Length up to 255.</div> */}
                                                    <div className="invalid-feedback">
                                                        {this.state.favUrlError}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>



                                        <div className="row">

                                            <div className="col-md-8">
                                                <div className="form-group shadow-sm p-3 mb-4 ">

                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" name="always_rebuild" checked={this.state.always_rebuild} onChange={this.handleChange} className="custom-control-input" id="always_rebuild" />
                                                        <label className="custom-control-label" htmlFor="always_rebuild">Always Rebuild</label>
                                                    </div>
                                                    <small>If selected, this report is always rebuilt when it runs. If not, this report may incrementally update data.</small>
                                                </div>
                                                <div className="form-group shadow-sm p-3 mb-4 ">

                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" name="alert_on_failure" checked={this.state.alert_on_failure} onChange={this.handleChange} className="custom-control-input" id="alert_on_failure" />
                                                        <label className="custom-control-label" htmlFor="alert_on_failure">Alert On Failure</label>
                                                    </div>
                                                        <small>If checked, this report will send notifications to the TAMs assigned to the account when the report fails to run.</small>
                                                </div>
                                                <div className="form-group shadow-sm p-3 mb-4">
                                                    <label>Query Strategy</label>
                                                    <select className="form-control col-md-6" name="query_strategy" value={this.state.query_strategy} onChange={this.handleChange}>
                                                        <option value="v3">v3</option>
                                                        <option value="legacy">legacy</option>
                                                    </select>
                                                    <small>v3 is the new preferred strategy for reporting. It is under test right now.</small>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group shadow-sm p-3 mb-4 ">
                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" name="ignore_health" checked={this.state.ignore_health} onChange={this.handleChange} className="custom-control-input" id="ignore_health" />
                                                    <label className="custom-control-label" htmlFor="ignore_health">Ignore Health</label>
                                                    </div>
                                                        <small>Check this to Ignore health </small>
                                                </div>
                                                <div className="form-group shadow-sm p-3 mb-4 ">
                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" name="lookup_table_optimization" checked={this.state.lookup_table_optimization} onChange={this.handleChange} className="custom-control-input" id="lookup_table_optimization" disabled={this.state.incremental_load_optimization} />
                                                        <label className="custom-control-label" htmlFor="lookup_table_optimization">Lookup Table Optimization</label>
                                                    </div>
                                                        <small>Check this for lookup table optimization</small>
                                                </div>
                                                <div className="form-group shadow-sm p-3 mb-4 ">
                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" name="incremental_load_optimization" checked={this.state.incremental_load_optimization} onChange={this.handleChange} className="custom-control-input" id="incremental_load_optimization" disabled={this.state.lookup_table_optimization}/>
                                                    <label className="custom-control-label" htmlFor="incremental_load_optimization">Incremental Load Optimization</label>
                                                    </div>
                                                        <small>Check this for incremental load optimization</small>
                                                </div>
                                                <div className="form-group shadow-sm p-3 mb-4 ">
                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" name="skip_when_priority_dependent_job" checked={this.state.skip_when_priority_dependent_job} onChange={this.handleChange} className="custom-control-input" id="skip_when_priority_dependent_job" />
                                                    <label className="custom-control-label" htmlFor="skip_when_priority_dependent_job">Skip When Parent Triggered By User</label>
                                                    </div>
                                                        <small >Check this to skip when parent triggered by user</small>
                                                </div>
                                                <div className="form-group shadow-sm p-3 mb-4 ">
                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" name="enabled" checked={this.state.enabled} onChange={this.handleChange} className="custom-control-input" id="enabled" />
                                                    <label className="custom-control-label" htmlFor="enabled">Enabled</label>
                                                    </div>
                                                        <small >Check this to enable</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xl-8 mt-4">
                                                <div className="form-group">
                                                    <h5>Custom SQL</h5>
                                                    <p className="hint-text text-muted">Any text here will override how data is read from the database. The report definition will be used only for column labeling.</p>
                                                    <Editor StringData={this.state.custom_sql} FormateType="mysql" onChange={this.editorhandleChange} />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>


                        <div className="text-center mt-3 mb-4">
                            {!this.state.isSaving && <Fragment><Link type="button" className="btn btn-lg btn-default" to="/report/list">{ButtonType.Cancel}</Link>
                                <input type="submit" className="btn btn-lg btn-primary ml-3" onClick={this.handleClick} value={ButtonType.Save} />
                                {/* <input type="submit" className="btn btn-lg btn-primary ml-3" value={ButtonType.SaveAndAddAnother} onClick={this.handleClick} /> */}
                                <input type="submit" className="btn btn-lg btn-primary ml-3" value={ButtonType.SaveAndEdit} onClick={this.handleClick} />
                            </Fragment>
                            }
                            <Loader loading={this.state.isSaving} marginBottom="10px" marginTop="8px" width="168px" ></Loader>
                        </div>
                    </div>
                </form>
                <Route path="/report/list" component={ReportList} />
            </Fragment >
        )
    }
}